import React from 'react';
import 'components/Filter/FilterBar/styles.scss';
import { FilterTiles } from '@spins/react-ui-library';
import { SelectionType } from 'utils/types';
import LoadingSpinner from 'components/LoadingSpinner';

export type FilterBarOptionType = {
  id: string;
  label: string;
  removable?: boolean;
  type: SelectionType;
};

interface Props {
  items: Array<FilterBarOptionType>;
  loading?: boolean;
  onClearAllClick(): void;
  onItemClick(id: string, type: string): void;
}

const FilterBar: React.FC<Props> = ({ items, loading = false, onClearAllClick, onItemClick }) => {
  const getFilterTiles = () => {
    return items.map((item) => ({
      id: item.id,
      label: item.label,
      onClick: item.removable ? () => onItemClick(item.id, item.type) : null,
    }));
  };

  if (items.length > 0 || loading) {
    if (loading) {
      return (
        <div className="filter-bar loading">
          <LoadingSpinner />
        </div>
      );
    }
    const canClearAll = items.some((item) => item.removable);
    return (
      <div className="filter-bar">
        <FilterTiles
          tiles={[...getFilterTiles()]}
          onClearAll={canClearAll ? () => onClearAllClick() : undefined}
        />
      </div>
    );
  }
  return null;
};

export default FilterBar;
